module.exports = __webpack_public_path__ + "static/InfoImage2-c008e38e991967b3cdaf9444e917814a.jpg";